import React, { useEffect, useState } from "react";
import { getPdfUrl } from "../../../services/DashboardServices";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Tooltip } from "@mui/material";
import downloadingIcon from '../../../assets/Gifs/Downloading.gif';

const PDFButton = ({ data }) => {
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    console.log("pdfButton", data);
  }, [data]);

  const getPdfUrlHandler = (sessionId) => {
    getPdfUrl(sessionId).then((res) => {
      if (res && res.data && res.data.data) {
        console.log(res.data.data);
        const a = document.createElement("a");
        a.href = res.data.data;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(res.data.data);
        setDownloading(false);
      } else {
        setDownloading(false);
      }
    });
  };
  return (
    <>
      {!downloading && (
        <div>
          <Tooltip title="Download">
            <FileDownloadOutlinedIcon
              sx={{
                width: "24px",
                height: "24px",
                color: "#788CFC",
                cursor: "pointer",
              }}
              onClick={() => {
                setDownloading(true);
                getPdfUrlHandler(data.encrypted_session_id);
              }}
            />
          </Tooltip>
        </div>
      )}
      {downloading && (
        <div>
         <div>
          <Tooltip
            title="
          Downloading Pdf Report 
          "
          >
            <img src={downloadingIcon} className="w-6 h-6" alt="" />
          </Tooltip>
        </div>
        </div>
      )}
    </>
  );
};

export default PDFButton;
